import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h2 className="footer__title">Wakil Ahmed</h2>

        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>

          <li>
            <a href="#portfolio" className="footer__link">
              Portfolio
            </a>
          </li>

          <li>
            <a href="#testimonials" className="footer__link">
              Testimonials
            </a>
          </li>
        </ul>

        <div className="footer__social">
          <a
            href="https://www.facebook.com/wakil.ahmed.581"
            className="footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <i className="bx bxl-facebook" aria-hidden="true"></i>
          </a>

          <a
            href="https://www.linkedin.com/in/wakil18"
            className="footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <i className="bx bxl-linkedin" aria-hidden="true"></i>
          </a>

          <a
            href="https://github.com/Wakil18"
            className="footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <i className="bx bxl-github" aria-hidden="true"></i>
          </a>
        </div>

        <span className="footer__copy">
          &#169; Wakil Ahmed. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
